import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ChangeDetectionStrategy
} from '@angular/core';
import { CrewMemberTypeAudit } from '../../+models/company-profile-audit.model';

@Component({
  selector: 'sd-portal-crew-member-type-audit-list',
  templateUrl: './crew-member-type-audit-list.component.html',
  styleUrls: ['./crew-member-type-audit-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CrewMemberTypeAuditListComponent implements OnInit {
  @Input() crewMemberTypeId: number;
  @Input() loading: boolean;
  @Input() crewMemberTypeAudits: CrewMemberTypeAudit[];

  @Output() loadCrewMemberType = new EventEmitter<number>();
  @Output() nextPage = new EventEmitter<number>();

  constructor() {}

  ngOnInit() {}

  loadData() {
    this.loadCrewMemberType.emit(this.crewMemberTypeId);
  }

  onNextPage() {
    this.nextPage.emit(this.crewMemberTypeId);
  }
}
